import {
  GET_EXTERNAL_PROJECTS_DETIALS_LOADING,
  GET_EXTERNAL_PROJECTS_DETIALS_SUCCESS,
  GET_EXTERNAL_PROJECTS_DETIALS_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";
import { getExternalProjectDetailsUrl } from "api/apiUrls";

export const getExternalProjectsDetailsActions =
  (projectId?: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: GET_EXTERNAL_PROJECTS_DETIALS_LOADING, payload: true });

      const response: any = await listSingleItemService(
        `${getExternalProjectDetailsUrl}`,
        `?projectId=${projectId}`
      );

      dispatch({
        type: GET_EXTERNAL_PROJECTS_DETIALS_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({ type: GET_EXTERNAL_PROJECTS_DETIALS_FAILURE, payload: err });
    } finally {
      dispatch({ type: GET_EXTERNAL_PROJECTS_DETIALS_LOADING, payload: false });
    }
  };
